<template>
  <Breadcrumbs
      title="Create Stock Allocation"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Stock Allocation', path: '/stock-allocation' },
      { label: 'Create Stock Allocation', path: '/new-stock-allocation' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <newStockAllocationForm/>
    </div>
  </div>
</template>


<script>
import newStockAllocationForm from '@/pages/stock/stock_allocation/newStockAllocationForm.vue';

export default {
  components: {
    newStockAllocationForm
  }
}
</script>